import { defineStore } from 'pinia'

import type { UsersStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useUsersStore = defineStore('users', {
  state: (): UsersStore => ({
    loading: false,
    saving: false,
    users: [],
    meta: null,
    teams: [],
    filterSearch: null,
    filterRoles: [],
    filterTeams: [],
    filterStatus: null,
    currentPage: 1,
    perPage: 25,
    userToDelete: null,
    currentUser: null,
  }),
  actions,
  getters,
})
